// Shared per-plan-type defaults for life/disability rate config. Used by both
// the plan-details Pricing tab (LifeDisabilityConfigForm) and the migration
// wizard's "Per benefit amount" editor so the two surfaces stay in step.

export type LifeDisabilityRateBasis = "benefit_amount" | "earnings_amount";
export type LifeDisabilityRateType = "composite" | "tiered";

export interface LifeDisabilityRateDefaults {
  rateBasis: LifeDisabilityRateBasis;
  rateType: LifeDisabilityRateType;
  rateUnitBasis: string;
}

export const RATE_BASIS_LABELS: Record<LifeDisabilityRateBasis, string> = {
  benefit_amount: "Per Benefit Amount",
  earnings_amount: "Per Earnings Amount",
};

export const RATE_TYPE_LABELS: Record<LifeDisabilityRateType, string> = {
  composite: "Composite Rate",
  tiered: "Tiered (Age-Banded) Rates",
};

export function getLifeDisabilityRateDefaults(
  planType: string | null | undefined,
): LifeDisabilityRateDefaults {
  const normalized = (planType ?? "").toLowerCase().trim();
  switch (normalized) {
    case "voluntary_life":
    case "life_voluntary":
      return {
        rateBasis: "benefit_amount",
        rateType: "tiered",
        rateUnitBasis: "1000",
      };
    case "std":
    case "ltd":
      return {
        rateBasis: "earnings_amount",
        rateType: "composite",
        rateUnitBasis: "100",
      };
    case "life":
    case "life_basic":
    case "disability":
    case "add":
    case "ad_d":
    case "add_basic":
    case "add_voluntary":
    case "accidental_death":
    case "accident":
    case "critical_illness":
    case "cancer":
    case "hospital_indemnity":
    default:
      return {
        rateBasis: "benefit_amount",
        rateType: "composite",
        rateUnitBasis: "1000",
      };
  }
}
